import { render } from "./InputCnae.vue?vue&type=template&id=83a8c0ca"
import script from "./InputCnae.vue?vue&type=script&lang=js"
export * from "./InputCnae.vue?vue&type=script&lang=js"
script.render = render

export default script